<app-e-agreement *ngIf="english"></app-e-agreement>
<app-e-agreement-hindi *ngIf="hindi"></app-e-agreement-hindi>
